import styled from "styled-components";

export const NoMarginBottom = styled.div`
    > div {
        margin-bottom: 6px;
    }
`;
